import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [membership, setMembership] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [wallets, setWallets] = useState({});
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem('gta_token');
    if (!token) { setLoading(false); return null; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user); setMembership(data.membership);
      setIsActive(data.is_active); setWallets(data.wallets || {});
      return data.user;
    } catch (e) {
      localStorage.removeItem('gta_token');
      setUser(null);
      return null;
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refreshMe(); }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('gta_token', data.access_token);
    localStorage.setItem('gta_refresh', data.refresh_token);
    await refreshMe();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('gta_token', data.access_token);
    localStorage.setItem('gta_refresh', data.refresh_token);
    await refreshMe();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('gta_token');
    localStorage.removeItem('gta_refresh');
    setUser(null); setMembership(null); setIsActive(false);
    window.location.href = '/';
  };

  const isAdmin = user && ['SUPER_ADMIN','ADMIN','ACADEMY_ADMIN','FINANCE_ADMIN','SUPPORT_ADMIN'].includes(user.role);

  return (
    <AuthContext.Provider value={{ user, membership, isActive, wallets, loading, login, register, logout, refreshMe, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};
